import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=65d6c36b"
import script from "./AutoLogout.vue?vue&type=script&lang=js"
export * from "./AutoLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d6c36b')) {
      api.createRecord('65d6c36b', component.options)
    } else {
      api.reload('65d6c36b', component.options)
    }
    module.hot.accept("./AutoLogout.vue?vue&type=template&id=65d6c36b", function () {
      api.rerender('65d6c36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/AutoLogout.vue"
export default component.exports